import { selectChatId, setMessageFeedback } from 'store/messages'
import { store } from '@/store'
import { FeedbackEnum } from 'types/chat-message'
import { captchaAxios } from 'api/config'
import { analytics, ANALYTICS_EVENTS } from 'services/analytics'

export const sendMessageFeedback = async ({ messageId, feedback }: { messageId: string; feedback: FeedbackEnum }) => {
  try {
    await captchaAxios.put(`chat-messages/${messageId}/feedback`, {
      feedback,
    })
    analytics.track(ANALYTICS_EVENTS.MESSAGE_FEEDBACK, { feedback })
    const chatId = selectChatId(store.getState())
    if (chatId) {
      store.dispatch(setMessageFeedback({ chatId, messageId, feedback }))
    }
  } catch (e) {
    console.error({ e })
  }
}
